import { render, staticRenderFns } from "./OptionsCarriers.vue?vue&type=template&id=47dfb1d2&scoped=true"
import script from "./OptionsCarriers.vue?vue&type=script&lang=js"
export * from "./OptionsCarriers.vue?vue&type=script&lang=js"
import style0 from "./OptionsCarriers.vue?vue&type=style&index=0&id=47dfb1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dfb1d2",
  null
  
)

export default component.exports